import { render, staticRenderFns } from "./newDocument.vue?vue&type=template&id=2cf8733e&scoped=true"
import script from "./newDocument.vue?vue&type=script&lang=js"
export * from "./newDocument.vue?vue&type=script&lang=js"
import style0 from "./newDocument.vue?vue&type=style&index=0&id=2cf8733e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf8733e",
  null
  
)

export default component.exports